/**
 * Status do WhatsApp de um pedido (CLUB-1131), a partir das mensagens que o
 * kyojin devolve em `whatsapp_messages` (whatsapp_audit, na ordem de envio).
 * Mesmos rótulos do shiso e do kemono.
 */
const STATUS = {
    read: { label: "Lido", tone: "ok", icon: "done_all", hint: "O vendedor abriu a mensagem." },
    delivered: { label: "Entregue", tone: "info", icon: "done_all", hint: "Chegou no WhatsApp do vendedor, mas ainda não foi lida." },
    sent: { label: "Enviado", tone: "neutral", icon: "done", hint: "Saiu do WhatsApp do Club e ainda não chegou no aparelho." },
    accepted: { label: "Aguardando", tone: "pending", icon: "schedule", hint: "A Meta aceitou a mensagem e ainda não confirmou o envio." },
    failed: { label: "Falhou", tone: "error", icon: "error", hint: "A Meta não conseguiu entregar a mensagem." },
};

export const NOT_SENT = {
    label: "Não enviado",
    tone: "muted",
    icon: "remove",
    hint: "Nenhuma mensagem de WhatsApp registrada para este pedido.",
};

export function whatsappStatus(status) {
    return STATUS[status] || { label: status || "–", tone: "neutral", icon: "help_outline", hint: "" };
}

/** O status que resume o pedido: o da mensagem mais recente. */
export function orderWhatsappStatus(order) {
    const messages = (order && order.whatsapp_messages) || [];
    if (!messages.length) return NOT_SENT;
    return whatsappStatus(messages[messages.length - 1].status);
}
